import React from 'react';
import { Link } from 'react-router-dom';
import { CandidateState } from '../../_generatedTypes.g';
import * as selectors from '../../selectors';
import { EditableCandidateItem } from './EditableCandidateItem';
import { useAppSelector } from '../../hooks';
import { checkCircleIcon } from '../ui/icons';
import { getTranslator, Translator } from '../../Translator';

type CandidateItemProps = {
    candidateId: string;
    candidateSystem: boolean;
    canShowCandidacyApproved: boolean;
}

export const CandidateItem = (props: CandidateItemProps) => {
    const account = useAppSelector(state => state.clientState.Account);
    const candidates = useAppSelector(state => state.candidates);
    const parties = useAppSelector(state => state.parties);
    const elections = useAppSelector(state => state.elections);
    const language = useAppSelector(state => state.language);
    const t = getTranslator(language);

    const candidate = candidates.filter(x => x.ClientSideId === props.candidateId)[0];
    const canEditCandidate = selectors.canEditCandidateStructure(account, candidates, parties, elections, candidate.CandidateId);

    return canEditCandidate
        ? <EditableCandidateItem candidateId={candidate.ClientSideId} candidateSystem={props.candidateSystem} canShowCandidacyApproved={candidate.IsApproved && props.canShowCandidacyApproved} />
        : <CandidateLink candidate={candidate} showCandidacyApproved={candidate.IsApproved && props.canShowCandidacyApproved} t={t} />
}

export const CandidateLink = (props: { candidate: CandidateState, showCandidacyApproved: boolean|null, t: Translator }) => 
    <Link
        id={`Party-Candidate-${props.candidate.CandidateId}`}
        key={props.candidate.CandidateId}
        className="party__candidate linkbutton button--important"
        to={`/candidate/${props.candidate.CandidateId}`}
        draggable="false">
        {props.candidate.Name} {props.showCandidacyApproved && <span title={props.t.translate({ NL: 'Kandidaatstelling goedgekeurd', EN: 'Candidacy approved' })}>{checkCircleIcon}</span>}
        &nbsp;
    </Link>

